module.exports = __webpack_public_path__ + "img/i_timepicker_dot.2190aa19.svg";